import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledInput = styledComponent('input', {
  padding: theme.spacing.inputPadding,
  border: theme.borders.input,
  borderRadius: theme.radii.input,
  ...theme.typography.label,
  color: theme.colors.textBody,
  width: '100%',
  boxSizing: 'border-box',
  transition: theme.transitions.default,
  '&:hover': {
    borderColor: theme.colors.focusRing,
  },
  '&:focus': {
    outline: 'none',
    borderColor: theme.colors.focusRing,
    boxShadow: `0 0 0 2px ${theme.colors.focusRing}33`,
  },
  '&[readonly]': {
    background: theme.colors.bgMuted,
    color: theme.colors.textMuted,
  },
  '&:disabled': {
    background: theme.colors.bgMuted,
    color: theme.colors.textMuted,
    cursor: 'not-allowed',
  },
});

function Input({
  id,
  type,
  value,
  onChange,
  placeholder,
  min,
  step,
  readOnly,
  disabled,
  style,
  'aria-label': ariaLabel,
}) {
  return (
    <StyledInput
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      min={min}
      step={step}
      readOnly={readOnly}
      disabled={disabled}
      style={style}
      aria-label={ariaLabel}
    />
  );
}

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  min: PropTypes.string,
  step: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  'aria-label': PropTypes.string,
};

Input.defaultProps = {
  id: undefined,
  type: 'text',
  value: undefined,
  onChange: undefined,
  placeholder: undefined,
  min: undefined,
  step: undefined,
  readOnly: false,
  disabled: false,
  style: undefined,
  'aria-label': undefined,
};

export default Input;
